// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDJ99xlYDLs4jkuiXSSllAxxYX58GbobGo",
    authDomain: "magnoliagroup-2a3cd.firebaseapp.com",
    databaseURL: "https://magnoliagroup-2a3cd.firebaseio.com",
    projectId: "magnoliagroup-2a3cd",
    storageBucket: "magnoliagroup-2a3cd.appspot.com",
    messagingSenderId: "901890971560",
    appId: "1:901890971560:web:4276ae75a89c15f9006f9d",
    measurementId: "G-XRHCGRLE26"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
